import React from 'react';
import { Link } from 'react-router-dom';
const has = require('lodash/has');

const Globals = require('../../../../app/globals');

const SignInStore = require('../../stores/SignInStore');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions'); // not sure that we need to look at current subscription plan. can we rely solely on userInfo.account_type?
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {

};

const defaultProps = {

};

class UpgradeIndividualPromoButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            signInStoreState: SignInStore.getState(),
            subscriptionPlan: SubscriptionPlanStore.getState().subscription_plan
        };

        this.unsubscribes = [
            SignInStore.listen(this.onSignInStoreChange.bind(this)),
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this))
        ];
    }

    UNSAFE_componentWillMount() {
        if (!this.subscriptionFetched(this.state.subscriptionPlan)) {
            SubscriptionPlanActions.getSubscriptionPlan();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onSignInStoreChange(newState) {
        this.setState({ signInStoreState: newState });
    }

    onSubscriptionPlanStoreChange(newState) {
        this.setState({ subscriptionPlan: newState.subscription_plan })
    }

    subscriptionFetched(subData) { // has subscription data been fetched from the server or do we only have a default store object?
        return has(subData, 'subscription');
    }

    render() {
        const eCommerceEnabled = GlobalConfig.DevOptions && GlobalConfig.DevOptions.ecommerce;

        if (!this.state.signInStoreState.initializedLocal || !eCommerceEnabled) {
            return null;
        }

        if (!this.subscriptionFetched(this.state.subscriptionPlan)) {
            return null;
        }

        const userInfo = this.state.signInStoreState.userInfo;

        if ([Globals.users.account_types.FREE, Globals.users.account_types.FREE_V2].indexOf(userInfo.account_type) !== -1) {
            return null;
        }

        return (
             <div className="inline-block">
                <Link className="link-plain btn btn-primary d-none d-sm-inline-block" to="/settings/subscription">
                        upgrade
                </Link>
                <Link className="link-plain link-brand d-inline-block d-sm-none aria-menu-trigger-padding" to="/settings/subscription">
                    <AccessibleIcon
                    label="upgrade">
                        <span className="fa fa-level-up" aria-hidden={true}/>
                    </AccessibleIcon>
                </Link>
            </div>
        );
    }
}

UpgradeIndividualPromoButton.propTypes = propTypes;
UpgradeIndividualPromoButton.defaultProps = defaultProps;

export default UpgradeIndividualPromoButton;